import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import axios from "axios";

import { API_URLS } from "src/utils/API_URLS";
import { getSelectDataSetForColumns } from "src/utils/methods";
import { AccessLinkPageContent } from "./components/AccessLinkPageContent/AccessLinkPageContent";

import "./AccessLinkPage.scss";

export function AccessLinkPage() {
  const { taskUuid, type, metafieldUuid, token } = useParams();
  const [response, setResponse] = useState(null);
  const [anyFieldRequired, setAnyFieldRequired] = useState(false);
  const [pageHandler, setPageHandler] = useState();

  const dispatch = useDispatch();

  const getTaskLinkData = async () => {
    try {
      const customLocale = new URLSearchParams(window.location.search).get(
        "locale",
      );

      let url = API_URLS.getTaskLinkData;

      if (customLocale) {
        url = `${url}?locale=${customLocale}`;
      }

      const {
        data: { content },
      } = await axios.get(url, {
        params: {
          wsMetaFieldUuid: metafieldUuid,
          token,
          metaFieldType: type,
          wsTaskUuid: taskUuid,
        },
      });
      setResponse(content);

      if (!content) setPageHandler("expired"); // if no response page is expired

      setAnyFieldRequired(
        content?.metaFields.filter((m) => m.metaFieldIsRequired).length > 0,
      );
    } catch (error) {
      setPageHandler("expired");
    }
  };

  useEffect(() => {
    if (!document.body.classList.contains("external-page")) {
      document.body.classList.add("external-page");
    }
    getTaskLinkData();
  }, []);

  useEffect(() => {
    if (response?.metaFields?.length) {
      getSelectDataSetForColumns(
        dispatch,
        response.metaFields.map((field) => ({
          ...field,
          options: field.data,
        })),
      );
    }
  }, [response?.metaFields]);

  return (
    <AccessLinkPageContent
      pageHandler={pageHandler}
      setPageHandler={setPageHandler}
      response={response}
      anyFieldRequired={anyFieldRequired}
    />
  );
}
